



























































import Vue from 'vue'
import _ from 'lodash'
import { CalendarEvent } from '@/model/planning/CalendarEvent'
import { Color, LanguageRow } from '@/types'
import ColorPicker from '@/components/ColorPicker.vue'
import CreateEventDialog from '@/components/settings/CreateEventDialog.vue'
import { CalendarEventSettingsPayload, CompanyInsertEventPayload } from '@/types/payload'
import { FETCH_EVENT_LIST, COMPANY_INSERT_CALENDAR_EVENT } from '@/store/action-types'
import { EventList } from '@/model/planning/EventList'

interface ComponentData {
  allEvents: Array<EventList>
  isPlannableCheckbox: boolean
  languageRows: Array<LanguageRow>
  showCreateEventDialog: boolean
  eventValidationRules: Array<Function>
  selectedEventId: number | null
  selectedCalendarEvent: CalendarEvent | undefined
  calendarEventColor: string | null
  isSelectionEnabled: boolean
  dialogSaveButtonLoading: boolean
}

export default Vue.extend({
  name: 'CalendarEventSettingsDialog',

  components: {
    ColorPicker,
    CreateEventDialog
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    calendarEvent: {
      type: Object as () => CalendarEvent
    },
    loading: Boolean,
    allCreatedEvents: {
      type: Array as ()=> Array<CalendarEvent>
    }
  },

  computed: {
    filteredEvents (): Array<EventList> {
      const createdEventsIds: Array<number> = this.allCreatedEvents.map((item: CalendarEvent) => {
        return item.eventId
      })
      const filteredEvents: Array<EventList> = _.filter(this.allEvents, (i: EventList) => !_.includes(createdEventsIds, i.id))

      return filteredEvents
    }
  },

  watch: {
    show (newVal: boolean) {
      if (newVal && this.calendarEvent) {
        this.selectedCalendarEvent = _.cloneDeep(this.calendarEvent)
        this.selectedEventId = this.selectedCalendarEvent.eventId
        this.isPlannableCheckbox = this.selectedCalendarEvent.isPlannable
        this.calendarEventColor = this.selectedCalendarEvent.color
        this.isSelectionEnabled = true
      } else {
        this.resetForm()
      }
    }
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.shifts.required').toString()

    return {
      allEvents: [],
      isPlannableCheckbox: false,
      languageRows: [],
      showCreateEventDialog: false,
      eventValidationRules: [
        required
      ],
      selectedEventId: null,
      selectedCalendarEvent: undefined,
      calendarEventColor: '#fff',
      isSelectionEnabled: false,
      dialogSaveButtonLoading: false
    }
  },

  methods: {

    createEvent (): void {
      this.showCreateEventDialog = true
    },

    onCreateEventDialogClose (): void {
      this.showCreateEventDialog = false
    },

    async onCreateEventDialogSave (languageRows: Array<LanguageRow>): Promise<void> {
      const payloadLanguages: CompanyInsertEventPayload = {
        languageRows: languageRows
      }
      try {
        this.dialogSaveButtonLoading = true
        await this.$store.dispatch(COMPANY_INSERT_CALENDAR_EVENT, payloadLanguages)
        this.dialogSaveButtonLoading = false
        this.showCreateEventDialog = false
        this.fetchCalendarEventList()
      } catch (e) {
        this.dialogSaveButtonLoading = false
      }
    },

    onCloseButtonClick (): void {
      this.$emit('close')
      this.resetForm()
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        const foundEvent: any = _.find(this.allEvents, { id: this.selectedEventId })
        const payload: CalendarEventSettingsPayload = {
          eventId: this.selectedEventId,
          eventName: foundEvent.eventName,
          color: this.calendarEventColor,
          isPlannable: this.isPlannableCheckbox,
        }
        this.$emit('save', payload)
      }
    },

    resetForm (): void {
      const form: any = this.$refs['form']
      if(form) {
        form.resetValidation()
      }

      this.selectedEventId = null
      this.selectedCalendarEvent = undefined
      this.isPlannableCheckbox = false
      this.calendarEventColor = '#fff'
      this.isSelectionEnabled = false

    },

    onColorChange (color: Color): void {
      if (color && color.hex) {
        this.calendarEventColor = color.hex
      }
    },

    async fetchCalendarEventList (): Promise<void> {
      const data: Array<EventList> = await this.$store.dispatch(FETCH_EVENT_LIST)
      this.allEvents = data
    }
  },

  async mounted () {
    this.fetchCalendarEventList()
  }

})
